<template>
  <Deploy />
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import Deploy from '@/app/features/admin/deploy/Deploy.vue';

  export default defineComponent({
    name: 'DeployPage',
    components: {
      Deploy,
    },
  });
</script>
